var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7505 19.689L15.0865 14.025C16.4475 12.391 17.1263 10.2951 16.9815 8.1734C16.8366 6.0517 15.8794 4.06752 14.3089 2.63361C12.7384 1.19971 10.6755 0.426482 8.54942 0.474791C6.42333 0.5231 4.39772 1.38922 2.89396 2.89298C1.3902 4.39674 0.524076 6.42236 0.475767 8.54844C0.427459 10.6745 1.20068 12.7374 2.63459 14.3079C4.0685 15.8784 6.05268 16.8356 8.17438 16.9805C10.2961 17.1253 12.3919 16.4466 14.026 15.0855L19.69 20.7495L20.7505 19.689ZM2.00045 8.74948C2.00045 7.41445 2.39633 6.10941 3.13803 4.99938C3.87973 3.88935 4.93394 3.02418 6.16734 2.51329C7.40074 2.0024 8.75794 1.86873 10.0673 2.12918C11.3767 2.38963 12.5794 3.0325 13.5234 3.97651C14.4674 4.92051 15.1103 6.12324 15.3708 7.43262C15.6312 8.74199 15.4975 10.0992 14.9866 11.3326C14.4757 12.566 13.6106 13.6202 12.5006 14.3619C11.3905 15.1036 10.0855 15.4995 8.75045 15.4995C6.96085 15.4975 5.24512 14.7857 3.97967 13.5203C2.71423 12.2548 2.00244 10.5391 2.00045 8.74948Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.f04481d59a0cccb3f0c86820c3045a39.svg";
export { ForwardRef as ReactComponent };